import useDictionary from '../../dictionaries/context/useDictionary';
import { Space } from '../types/Space';
import { SpaceContext } from '../types/SpaceContext';

/**
 * Adds rendered text from dictionary to space object, if exists, and returns new space object
 * @param space original space object
 * @param spaceContext space context object
 * @param gT get text from dictionary util
 * @returns space with text, if exists
 */
export const addTextToSpace = (
  space: Space,
  spaceContext: SpaceContext,
  gT: ReturnType<typeof useDictionary>['gT'],
) => {
  const context = { ...spaceContext, ...space.extraContext };
  return {
    ...space,
    // si existe la llave, trae el texto usando el mismo contexto
    text: space.keyIf && gT(space.key, context),
    context,
  };
};
